<template>
    <div class="mb-3">
        <b for="name" v-if="label" class="form-label">{{ label }}</b>

        <input type="text" :placeholder="label" :disabled="disabled" :readonly="readonly" :value="modelValue"
            @input="handleInput($event)" @keypress="isFloat($event)" class="form-control" />

        <span class="text-danger" v-for="error in v?.$errors" :key="error.$uid">
            - {{ error.$message }} <br>
        </span>
    </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    modelValue: {
        type: Number,
        default: 0,
    },
    
    label: String,
    placeholder: {
        type: String,
        default: 'Enter price',
    },
    disabled: Boolean,
    readonly: Boolean,
    v: Object
});

const emits = defineEmits(['update:modelValue']);

const handleInput = (event: any) => {
    let val = event.target.value;

    // Convert to float
    let num = parseFloat(val);

    // If NaN → emit empty or zero
    if (isNaN(num)) {
        emits('update:modelValue', '');
        return;
    }
 

    emits('update:modelValue', num);
};

const isFloat = (event: KeyboardEvent) => {
    const key = event.key;
    const currentValue = (event.target as HTMLInputElement).value;

    // Allow digits & one dot
    if (!/[\d.]/.test(key)) {
        event.preventDefault();
        return;
    }

    // Block second dot
    if (key === '.' && currentValue.includes('.')) {
        event.preventDefault();
    }
};
</script>
